// Base URLs are resolved from environment variables so local development and
// automated tests never accidentally hit production, and production builds
// never accidentally ship pointed at localhost.
//
// Set REACT_APP_BASE_URL / REACT_APP_ADMIN_BASE_URL in .env.development,
// .env.production, or .env.local to override these defaults.
module.exports.base_url =
  process.env.REACT_APP_BASE_URL || 'https://www.cmsapi.scientexconference.com/';
module.exports.admin_base_url =
  process.env.REACT_APP_ADMIN_BASE_URL || 'https://www.admin.scientexconference.com/';
